"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParentBindingConstraintsWithName = isParentBindingConstraintsWithName;
const isBindingConstraintsWithName_1 = require("./isBindingConstraintsWithName");
const isParentBindingConstraints_1 = require("./isParentBindingConstraints");
function isParentBindingConstraintsWithName(name) {
    return (0, isParentBindingConstraints_1.isParentBindingConstraints)((0, isBindingConstraintsWithName_1.isBindingConstraintsWithName)(name));
}
//# sourceMappingURL=isParentBindingConstraintsWithName.js.map